import React from "react";
import { Link, useNavigate } from "react-router-dom";

import './BackLink.css';

type BackLinkProps = {
  children: React.ReactNode;
  to?: string;
  dynamic?: boolean;
  state?: any;
}

export const BackLink = ({ children, to = "", dynamic, state }: BackLinkProps) => {
  let navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  }

  return (
    <>
      {dynamic ? (
        <button onClick={goBack} className="gds-back-link gds-back-link--button">{children}</button>
      ) : (
        <>
          {state ? (
            <Link to={to} state={state} className="gds-back-link">{children}</Link>
          ) : (
            <Link to={to} className="gds-back-link">{children}</Link>
          )}
        </>
      )}
    </>
  )
}
